import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

const CART_STORAGE_KEY = 'fla_cartItems';

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState(() => {
        try {
            const guardado = localStorage.getItem(CART_STORAGE_KEY);
            return guardado ? JSON.parse(guardado) : [];
        } catch (e) {
            console.error("No se pudo leer el carrito de localStorage:", e);
            return [];
        }
    });

    // Persiste el carrito ante cada cambio para que sobreviva recargas de página.
    useEffect(() => {
        try {
            localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cartItems));
        } catch (e) {
            console.error("No se pudo guardar el carrito en localStorage:", e);
        }
    }, [cartItems]);

    // Se actualiza en cada addToCart; el navbar lo escucha para disparar la
    // animación del carrito flotante (destello dorado) sin necesitar comparar
    // cartItems entero (que cambia también al editar cantidad en el carrito).
    const [ultimoAgregado, setUltimoAgregado] = useState(0);

    const addToCart = (vino, cantidad = 1) => {
        setCartItems(prevItems => {
            const existe = prevItems.find(item => item.vino.id === vino.id);
            if (existe) {
                return prevItems.map(item =>
                    item.vino.id === vino.id
                        ? { ...item, cantidad: item.cantidad + cantidad }
                        : item
                );
            } else {
                return [...prevItems, { vino, cantidad }];
            }
        });
        setUltimoAgregado(Date.now());
    };

    const removeFromCart = (vinoId) => {
        setCartItems(prevItems => prevItems.filter(item => item.vino.id !== vinoId));
    };

    const updateQuantity = (vinoId, newCantidad) => {
        setCartItems(prevItems => {
            if (newCantidad <= 0) {
                return prevItems.filter(item => item.vino.id !== vinoId);
            }
            return prevItems.map(item =>
                item.vino.id === vinoId
                    ? { ...item, cantidad: newCantidad }
                    : item
            );
        });
    };

    // FUNCIÓN PARA VACIAR EL CARRITO
    const clearCart = () => {
        setCartItems([]);
    };

    const totalItems = cartItems.reduce((acc, item) => acc + item.cantidad, 0);
    
    const totalCompra = cartItems.reduce((acc, item) => {
        return acc + (item.vino.precioUnidad * item.cantidad);
    }, 0);

    return (
        <CartContext.Provider value={{
            cartItems,
            addToCart,
            removeFromCart,
            updateQuantity,
            totalItems,
            totalCompra,
            setCartItems,
            clearCart, // <--- AÑADIDO AL CONTEXTO
            ultimoAgregado,
        }}>
            {children}
        </CartContext.Provider>
    );
};